<script setup lang="ts">
  import { computed, onBeforeUnmount, onMounted, ref } from "vue";
  import { useRoute } from "vue-router";
  import member1 from "~/assets/images/about/founder/member1.png";
  import member2 from "~/assets/images/about/founder/member2.png";
  import member3 from "~/assets/images/about/founder/member3.png";
  import dlcpry1 from "~/assets/images/about/honorary-certificate/dlcpry1.png";
  import dlcpry2 from "~/assets/images/about/honorary-certificate/dlcpry2.png";
  import dlcpry3 from "~/assets/images/about/honorary-certificate/dlcpry3.png";
  import dlcpry4 from "~/assets/images/about/honorary-certificate/dlcpry4.png";
  import dlcpry5 from "~/assets/images/about/honorary-certificate/dlcpry5.png";
  import dlcpry6 from "~/assets/images/about/honorary-certificate/dlcpry6.png";
  import dlkjry1 from "~/assets/images/about/honorary-certificate/dlkjry1.png";
  import dlkjry2 from "~/assets/images/about/honorary-certificate/dlkjry2.png";
  import dlkjry3 from "~/assets/images/about/honorary-certificate/dlkjry3.png";
  import dlkjry4 from "~/assets/images/about/honorary-certificate/dlkjry4.png";
  import dlkjzz1 from "~/assets/images/about/honorary-certificate/dlkjzz1.png";
  import dlkjzz2 from "~/assets/images/about/honorary-certificate/dlkjzz2.png";
  import dlkjzz3 from "~/assets/images/about/honorary-certificate/dlkjzz3.png";
  import dlkjzz4 from "~/assets/images/about/honorary-certificate/dlkjzz4.png";
  import dlkjzz5 from "~/assets/images/about/honorary-certificate/dlkjzz5.png";
  import dlkjzz6 from "~/assets/images/about/honorary-certificate/dlkjzz6.png";
  import patent1 from "~/assets/images/about/patent/patent1.png";
  import patent2 from "~/assets/images/about/patent/patent2.png";
  import patent3 from "~/assets/images/about/patent/patent3.png";
  import patent4 from "~/assets/images/about/patent/patent4.png";
  import patent5 from "~/assets/images/about/patent/patent5.png";
  import patent6 from "~/assets/images/about/patent/patent6.png";
  import patent7 from "~/assets/images/about/patent/patent7.png";
  import patent9 from "~/assets/images/about/patent/patent9.png";
  import patent12 from "~/assets/images/about/patent/patent12.png";
  import patent13 from "~/assets/images/about/patent/patent13.png";
  import patent17 from "~/assets/images/about/patent/patent17.png";
  // import BaiduMap from "~/components/BaiduMap.client.vue";
  import { DATA_URL, DLS_URL } from "~/env";
  import listener from "~/utils/listener";

  // import BaiduMap from "~/components/BaiduMap.client.vue";

  // import loadBaiduMap from "~/utils/loadBaiduMap";

  definePageMeta({
    layout: "nav-layout",
  });

  useHead({
    titleTemplate: "关于得理 - %s",
  });

  interface Certificate {
    text: string;
    imgUrl: string;
    enlargeImgUrl: string;
  }

  // const mapLoaded = ref(false);
  // const center = ref<{ lng: number; lat: number }>({ lng: 113.951363, lat: 22.537122 });
  // const zoom = ref<number>(17);

  onMounted(async () => {
    const type = route.query.type as string;

    // try {
    //   await loadBaiduMap();
    //   mapLoaded.value = true;
    // } catch (error) {
    //   console.error("百度地图加载失败:", error);
    // }

    setTimeout(() => {
      onPosition(type);
    }, 200);

    api.site();
    loadCompanyNewsTypeList();
    loadCompanyNewsData();
    listener.on("onAboutPosition", onPosition);
  });

  const introduction = ref<HTMLElement | null>(null);
  const honorRef = ref();
  const honorShowcaseRef = ref();
  const origin = ref<HTMLElement | null>(null);

  const api = useApi();

  // 公司动态
  const COMPANY_NEWS_PAGE_SIZE = 3;
  const companyNewsActiveTab = ref("0");
  const companyNewsTypeList = ref<any[]>([]);
  const companyNewsItems = ref<any[]>([]);
  const companyNewsLoading = ref(false);
  const companyNewsTotalPage = ref(0);
  const companyNewsPageNo = ref(1);

  const loadCompanyNewsTypeList = async () => {
    try {
      const res = await api.newsQueryType("company");
      companyNewsTypeList.value = [{ value: "0", label: "全部" }, ...res];
    } catch (e) {
      console.error(e);
    }
  };

  const loadCompanyNewsData = async () => {
    companyNewsLoading.value = true;
    try {
      const { data, totalCount } = await api.newsQuery({
        pageNo: companyNewsPageNo.value,
        pageSize: COMPANY_NEWS_PAGE_SIZE,
        type: "company",
        category: companyNewsActiveTab.value === "0" ? "" : companyNewsActiveTab.value,
      });
      companyNewsItems.value = data;
      companyNewsTotalPage.value = Math.ceil(totalCount / COMPANY_NEWS_PAGE_SIZE);
    } catch (e) {
      console.error(e);
    } finally {
      companyNewsLoading.value = false;
    }
  };

  const onCompanyNewsTabChange = async (category: string) => {
    companyNewsActiveTab.value = category;
    companyNewsPageNo.value = 1;
    await loadCompanyNewsData();
  };

  const onCompanyNewsPageChange = async (page: number) => {
    if (page < 1 || page > companyNewsTotalPage.value) return;
    companyNewsPageNo.value = page;
    await loadCompanyNewsData();
  };

  const patentCertificate = ref<Certificate[]>([
    {
      text: "专利证书——一种基于深度学习无监督文本检索方法",
      imgUrl: patent1,
      enlargeImgUrl: patent1,
    },
    {
      text: "专利证书——图像检索方法、商标检索方法、电子设备以及存储介质",
      imgUrl: patent2,
      enlargeImgUrl: patent2,
    },
    {
      text: "专利证书——数据检索方法、装置、设备及计算机可读存储介质",
      imgUrl: patent3,
      enlargeImgUrl: patent3,
    },
    {
      text: "专利证书——一种基于深度学习的长文本检索系统及方法发明专利证书(签章)",
      imgUrl: patent4,
      enlargeImgUrl: patent4,
    },
    // {
    //   text: "专利证书——一种基于深度学习的长文本检索系统及方法",
    //   imgUrl: patentCertificate5,
    //   enlargeImgUrl: patentCertificate5Enlarge,
    // },
  ]);

  const honoraryCertificate = ref<Certificate[]>([
    {
      text: "专利证书—一种逐句段对比的相似文本查找方法及装置",
      imgUrl: patent5,
      enlargeImgUrl: patent5,
    },
    {
      text: "专利证书—问答模型的训练方法、计算机设备以及可读存储介质",
      imgUrl: patent6,
      enlargeImgUrl: patent6,
    },
    {
      text: "专利证书—中文分词方法、训练设备以及计算机可读存储介质",
      imgUrl: patent7,
      enlargeImgUrl: patent7,
    },
    {
      text: "专利证书—一种基于对比学习的长文本检索模型",
      imgUrl: patent9,
      enlargeImgUrl: patent9,
    },
  ]);

  const memberUnit = ref<Certificate[]>([
    {
      text: "专利证书—关键词提取方法、文本检索方法及相关设备",
      imgUrl: patent12,
      enlargeImgUrl: patent12,
    },
    {
      text: "专利证书—文本关键信息提取方法、装置、设备以及计算机存储介质",
      imgUrl: patent13,
      enlargeImgUrl: patent13,
    },
    {
      text: "专利证书—案例检索方法、装置、计算机设备及存储介质",
      imgUrl: patent17,
      enlargeImgUrl: patent17,
    },
    // {
    //   text: "第五届全国青年人工智能创新创业大会创新组一等奖",
    //   imgUrl: memberUnit4,
    //   enlargeImgUrl: memberUnit4Enlarge,
    // },
  ]);

  const pictureList = computed<Certificate[]>(() => {
    return [...patentCertificate.value, ...honoraryCertificate.value];
  });

  interface ShowcaseItem {
    imgUrl: string;
    text: string;
    type?: "vertical" | "horizontal";
    enlargeImgUrl?: string;
  }

  const qualificationList: ShowcaseItem[] = [
    { imgUrl: dlkjzz1, text: "高新技术企业", type: "horizontal" },
    { imgUrl: dlkjzz2, text: "深圳市人工智能学会会员单位", type: "horizontal" },
    { imgUrl: dlkjzz3, text: "深圳市互联网创业创新服务促进会会员单位", type: "horizontal" },
    { imgUrl: dlkjzz6, text: "深圳市人工智能行业协会副会长单位", type: "horizontal" },
    { imgUrl: dlkjzz4, text: "广东省人工智能产业协会会员单位", type: "horizontal" },
    { imgUrl: dlkjzz5, text: "第一届上海法律科技协会会员单位", type: "horizontal" },
  ];

  const techHonorList: ShowcaseItem[] = [
    { imgUrl: dlkjry1, text: 'AIC2025年度智创未来"商业价值奖"' },
    { imgUrl: dlkjry2, text: '第六届深圳国际人工智能展览会（GAIE）"最受欢迎人工智能产品奖"' },
    { imgUrl: dlkjry3, text: "第十四届自然语言处理与中文计算国际会议（NLPCC2025）黄金赞助商", type: "horizontal" },
    { imgUrl: dlkjry4, text: "2025企业新质生产力标杆案例" },
  ];

  const productHonorList: ShowcaseItem[] = [
    {
      imgUrl: dlcpry1,
      text: '得理科技"法律智能问答大模型"荣获全国人工智能应用场景创新挑战赛 智能司法专项赛成长组"特等奖"',
    },
    {
      imgUrl: dlcpry2,
      text: '"得理知识产权法律AI系统"荣获第二十六届中国国际高新技术成果交易会"优秀科研成果创新奖"',
    },
    {
      imgUrl: dlcpry3,
      text: '"得理法问"荣获第二十六届中国国际高新技术成果交易会"优秀科研成果创新奖"',
    },
    {
      imgUrl: dlcpry4,
      text: '"得理法律大模型"通过国家网信办深度合成服务算法备案',
      type: "horizontal",
    },
    {
      imgUrl: dlcpry5,
      text: '"得理律助"荣获2024年度最受上海律师欢迎的法律科技产品',
    },
    {
      imgUrl: dlcpry6,
      text: '"得理法搜"荣获2025深圳法律服务博览会，法律科技产品大赛"卓越技术奖"',
    },
  ];

  const founderList = [
    {
      img: member1,
      name: "杨敏",
      profession: "首席科学家、联合创始人",
      info: [
        "香港大学计算机博士",
        "中科院深圳先进院数据挖掘实验室主任",
        "深圳市高性能数据挖掘重点实验室主任",
        "连续四年入选全球前2%顶尖科学家",
        "长期从事人工智能、大模型、自然语言处理相关研究",
        "发表高水平学术论文240余篇，谷歌学术引用10000余次，H-index53",
      ],
    },
    {
      img: member2,
      name: "贺倩明",
      profession: "联合创始人",
      info: [
        "中国政法大学经济法博士",
        "国内知名律所主任、高级合伙人",
        "中科院深圳先进院-得理法律人工智能实验室执行主任",
        "深圳市人工智能行业协会副会长",
        "深圳市人工智能行业协会智慧法律专委会主任",
      ],
    },
    {
      img: member3,
      name: "雷宇",
      profession: "联合创始人、CTO",
      info: [
        "中科院先进院得理法律人工智能实验室副主任",
        "深圳市人工智能学会法律专委会秘书长",
        "先后任职于百度、腾讯",
        "超过10年一线互联网企业研发管理经验",
        "专注于大数据和大模型算法",
      ],
    },
  ];

  const onPosition = (type?: string): void => {
    if (type) {
      const refMap: Record<string, HTMLElement | null> = {
        introduction: introduction.value,
        honor: honorRef.value,
        origin: origin.value,
      };

      refMap[type]?.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }
  };

  const onGotoProduct = (type: string): void => {
    switch (type) {
      case "ai":
        window.open("/ai", "_blank");
        break;
      case "data":
        window.open(DATA_URL, "_blank");
        break;
      case "dls":
        window.open(DLS_URL, "_blank");
        break;
    }
  };

  const route = useRoute();

  onBeforeUnmount(() => {
    listener.off("onAboutPosition", onPosition);
  });
</script>

<template>
  <div class="container">
    <div class="banner">
      <div class="title-wrap">
        <h3>- 得理科技 -</h3>
        <h1>法律大模型驱动的 </h1>
        <h1>AI+律师 平台服务商</h1>
      </div>
    </div>
    <div ref="introduction" class="introduction">
      <div class="content">
        <h1 class="tip">公司简介</h1>
        <div class="box">
          <img src="~/assets/images/logo.svg" />
          <div class="text">
            <h2>得理科技有限公司</h2>
            <p>
              深圳得理科技有限公司成立于2018年，是一家由国内顶级法律团队和 AI
              团队联合发起的法律科技公司，并于2019年联手中科院深圳先进院成立法律人工智能实验室，专注法律行业AI模型算法研究。
            </p>
            <p>
              其自研的法律行业AI大模型达到业内领先水平，以得理法律AI大模型为基础，得理科技还研发了得理律助和得理法搜两条主要产品线，以小理AI和小理智能体为核心组件，为法律人、企业及个人提供一揽子法律+AI解决方案。
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="founder">
      <h1 class="tip tw-text-center tw-text-[40px] tw-font-[600] tw-leading-[47px] tw-text-[#1F1F1F]">
        联合创始人团队
      </h1>
      <div class="box">
        <div v-for="(founder, idx) in founderList" :key="idx" class="founder-item">
          <div class="photo-card">
            <img :src="founder.img" alt="" />
            <div class="title-overlay">
              <div class="name-row">
                <div class="accent-bar"></div>
                <div class="name">{{ founder.name }}</div>
              </div>
              <div class="profession">{{ founder.profession }}</div>
            </div>
          </div>
          <div class="info">
            <div v-for="(text, i) in founder.info" :key="i" class="info-item tw-flex tw-items-start">
              <div
                class="tw-mr-[10px] tw-mt-[15px] tw-flex-shrink-0 tw-rounded-[50%] tw-bg-[rgba(66,133,244,0.3)] tw-wh-[10px]"></div>
              <div class="intro tw-text-[#5A5D66]">{{ text }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div ref="honorShowcaseRef" class="honor-showcase">
      <div class="showcase-section">
        <div class="showcase-title-wrap">
          <h1 class="showcase-title">得理科技部分资质展示</h1>
        </div>
        <div class="showcase-row">
          <a-tooltip
            v-for="(item, i) in qualificationList"
            :key="i"
            trigger="hover"
            placement="top"
            :get-popup-container="() => honorShowcaseRef">
            <template #title>
              <div class="img-enlarge">
                <p>{{ item.text }}</p>
                <img :src="item.enlargeImgUrl || item.imgUrl" />
              </div>
            </template>
            <div class="showcase-item">
              <div :class="{ '!tw-h-auto !tw-w-[170px]': item?.type === 'horizontal' }">
                <img class="!tw-h-auto !tw-w-[170px]" :src="item.imgUrl" :alt="item.text" />
              </div>
              <p class="showcase-label">{{ item.text }}</p>
            </div>
          </a-tooltip>
        </div>
      </div>

      <div class="showcase-section">
        <div class="showcase-title-wrap">
          <h1 class="showcase-title">得理科技部分荣誉展示</h1>
        </div>
        <div class="showcase-row !tw-gap-[260px]">
          <a-tooltip
            v-for="(item, i) in techHonorList"
            :key="i"
            trigger="hover"
            placement="top"
            :get-popup-container="() => honorShowcaseRef">
            <template #title>
              <div class="img-enlarge">
                <p>{{ item.text }}</p>
                <img :src="item.enlargeImgUrl || item.imgUrl" />
              </div>
            </template>
            <div class="showcase-item">
              <div class="showcase-img-wrap">
                <img
                  :class="{ '!tw-h-auto !tw-w-[170px]': item?.type === 'horizontal' }"
                  :src="item.imgUrl"
                  :alt="item.text" />
              </div>
              <p class="showcase-label">{{ item.text }}</p>
            </div>
          </a-tooltip>
        </div>
      </div>

      <div ref="honorRef" class="honor showcase-section">
        <h1 class="tip">得理科技专利</h1>
        <!-- <h3>
        截至2024年，公司已拥有15+AI专利技术，得理法律大模型成为首批通过国家网信办备案的生成式算法，公司技术团队累计发表上百篇权威学术论文，收获国际法律AI大赛等多项比赛奖项和行业荣誉，并被认定为“国家高新技术企业”。
      </h3> -->
        <div class="carousel">
          <a-carousel :dots="false" autoplay arrows>
            <template #prevArrow>
              <div class="prev-arrow">
                <icon-font class="arrow" type="jiantou" />
                <!-- <Icon class="arrow" name="custom:jiantou" />-->
              </div>
            </template>
            <template #nextArrow>
              <div class="next-arrow">
                <icon-font class="arrow" type="fanhui" />
                <!-- <Icon class="arrow" name="custom:fanhui" />-->
              </div>
            </template>
            <div class="patent-certificate">
              <div class="img-wrap">
                <a-tooltip
                  v-for="(item, index) in patentCertificate"
                  :key="index"
                  :get-popup-container="() => honorRef"
                  trigger="hover"
                  placement="top">
                  <template #title>
                    <div class="img-enlarge">
                      <p>{{ item.text }}</p>
                      <img :src="item.enlargeImgUrl" />
                    </div>
                  </template>
                  <div class="img-item">
                    <img :src="item.imgUrl" />
                  </div>
                </a-tooltip>
              </div>
            </div>
            <div class="honorary-certificate">
              <div class="img-wrap">
                <a-tooltip
                  v-for="(item, index) in honoraryCertificate"
                  :key="index"
                  :get-popup-container="() => honorRef"
                  trigger="hover"
                  placement="top">
                  <template #title>
                    <div class="img-enlarge">
                      <p>{{ item.text }}</p>
                      <img :src="item.enlargeImgUrl" />
                    </div>
                  </template>
                  <div class="img-item">
                    <img :src="item.imgUrl" />
                  </div>
                </a-tooltip>
              </div>
            </div>
            <div class="member-unit">
              <div class="img-wrap">
                <a-tooltip
                  v-for="(item, index) in memberUnit"
                  :key="index"
                  :get-popup-container="() => honorRef"
                  trigger="hover"
                  :align="{
                    points: ['bc', 'tl'],
                    overflow: { adjustX: true, adjustY: true },
                  }">
                  <template #title>
                    <div class="img-enlarge">
                      <p>{{ item.text }}</p>
                      <img :src="item.enlargeImgUrl" />
                    </div>
                  </template>
                  <div class="img-item">
                    <img :src="item.imgUrl" />
                  </div>
                </a-tooltip>
              </div>
            </div>
          </a-carousel>
        </div>
        <div class="picture-list">
          <img v-for="(picture, i) in pictureList" :key="i" :src="picture.enlargeImgUrl" alt="" />
        </div>
      </div>

      <div class="showcase-section">
        <div class="showcase-title-wrap">
          <h1 class="showcase-title">得理产品部分荣誉展示</h1>
        </div>
        <div class="showcase-row">
          <a-tooltip
            v-for="(item, i) in productHonorList"
            :key="i"
            trigger="hover"
            placement="top"
            :get-popup-container="() => honorShowcaseRef">
            <template #title>
              <div class="img-enlarge">
                <p>{{ item.text }}</p>
                <img :src="item.enlargeImgUrl || item.imgUrl" />
              </div>
            </template>
            <div class="showcase-item">
              <div class="showcase-img-wrap">
                <img
                  :class="{ '!tw-h-auto !tw-w-[170px]': item?.type === 'horizontal' }"
                  :src="item.imgUrl"
                  :alt="item.text" />
              </div>
              <p class="showcase-label">{{ item.text }}</p>
            </div>
          </a-tooltip>
        </div>
      </div>
    </div>

    <div class="develop-history tw-px-[65px] tw-py-[130px] md:tw-px-[0]">
      <h1 class="tip tw-text-center tw-text-[40px] tw-font-[600] tw-leading-[47px] tw-text-[#1F1F1F]">公司发展历程</h1>

      <img class="tw-hidden md:tw-block" src="~/assets/images/about/develop-history/bg.png" alt="" />
      <img class="tw-mt-[70px] md:tw-hidden" src="~/assets/images/about/develop-history/minibg.png" alt="" />
    </div>

    <div ref="origin" class="origin">
      <h1 class="tip">“得理者，知未来”</h1>
      <h4> 公司以“得理”为名，取“得”字之“行有所得”与“理”字“规律”之义，欲将人类智慧与机 </h4>
      <h4>器智慧相结合，继以参透法律之理。</h4>
      <div class="content box1">
        <div class="row">
          <div class="item text one">
            <div class="icon-wrap">
              <icon-font type="AIfunengfalv" />
              <!-- <Icon name="custom:aifunengfalv" />-->
            </div>
            <span class="tw-text-[20px] tw-font-[500] tw-text-white">使命</span>
            <span class="desc">用AI赋能法律，让法律普惠于民</span>
          </div>
          <div class="item">
            <img src="~/assets/images/about/origin/legal-value.png" />
          </div>
          <div class="item text three">
            <div class="icon-wrap">
              <icon-font type="rangfalvpuhuiyumin" />
              <!-- <Icon name="custom:rangfalvpuhuiyumin" />-->
            </div>
            <span class="tw-text-[20px] tw-font-[500]">价值观</span>
            <span class="desc">守正创新，共享价值</span>
          </div>
        </div>
        <div class="row">
          <div class="item">
            <img src="~/assets/images/about/origin/ai-empowering-law.png" />
          </div>
          <div class="item text five">
            <div class="icon-wrap">
              <icon-font type="jiazhi" />
              <!-- <Icon name="custom:jiazhi" />-->
            </div>
            <span class="tw-text-[20px] tw-font-[500]">愿景</span>
            <span class="desc">致力于成为全球领先的法律AI服务商</span>
          </div>
          <div class="item">
            <img src="~/assets/images/about/origin/legal-inclusive.png" />
          </div>
        </div>
      </div>
      <div class="content box2 tw-hidden">
        <div class="item text one">
          <div class="icon-wrap">
            <icon-font type="AIfunengfalv" />
            <!-- <Icon name="custom:aifunengfalv" />-->
          </div>
          <span class="desc">AI赋能法律</span>
        </div>
        <div class="item">
          <img src="~/assets/images/about/origin/ai-empowering-law.png" />
        </div>
        <div class="item text three">
          <div class="icon-wrap">
            <icon-font type="rangfalvpuhuiyumin" />
            <!-- <Icon name="custom:rangfalvpuhuiyumin" />-->
          </div>
          <span class="desc">让法律普惠于民</span>
        </div>
        <div class="item">
          <img src="~/assets/images/about/origin/legal-inclusive.png" />
        </div>
        <div class="item">
          <img src="~/assets/images/about/origin/legal-value.png" />
        </div>
        <div class="item text five">
          <div class="icon-wrap">
            <icon-font type="jiazhi" />
            <!-- <Icon name="custom:jiazhi" />-->
          </div>
          <span class="desc">守正创新，共享价值</span>
        </div>
      </div>
    </div>

    <div class="company-news">
      <div class="company-news-inner">
        <div class="company-news-title-wrap">
          <h1 class="company-news-title">公司动态</h1>
        </div>
        <!-- 分类 tab -->
        <div class="company-news-tabs">
          <div
            v-for="tab in companyNewsTypeList"
            :key="tab.value"
            class="company-news-tab"
            :class="{ active: companyNewsActiveTab === tab.value }"
            @click="onCompanyNewsTabChange(tab.value)">
            {{ tab.label }}
          </div>
        </div>
        <!-- 3 列卡片 -->
        <div class="company-news-grid">
          <nuxt-link
            v-for="item in companyNewsItems"
            :key="item.id"
            class="company-news-card"
            :to="`/news/company/${item.id}`"
            target="_blank">
            <div class="company-news-card-img">
              <img v-if="item.pictureUrl" :src="item.pictureUrl" :alt="item.title" />
            </div>
            <div class="company-news-card-body">
              <div class="company-news-card-label">{{ item.label }}</div>
              <div class="company-news-card-title">{{ item.title }}</div>
            </div>
          </nuxt-link>
        </div>
        <!-- 分页 -->
        <div class="company-news-pagination">
          <div class="news-nav-btn" @click="onCompanyNewsPageChange(companyNewsPageNo - 1)">
            <img src="~/assets/images/home/new/left.png" alt="prev" />
          </div>
          <div class="news-dots">
            <div
              v-for="page in companyNewsTotalPage"
              :key="page"
              class="news-dot"
              :class="{ active: page === companyNewsPageNo }"
              @click="onCompanyNewsPageChange(page)"></div>
          </div>
          <div class="news-nav-btn" @click="onCompanyNewsPageChange(companyNewsPageNo + 1)">
            <img src="~/assets/images/home/new/right.png" alt="next" />
          </div>
        </div>
      </div>
    </div>

    <div class="map">
      <div class="address">
        <div class="address-left">
          <h1>联系我们</h1>
          <div class="item">
            <p class="tw-text-[20px] tw-font-[600] tw-text-[#333]">
              <icon-font type="Group2894" />
              <!-- <Icon name="custom:group2894" />-->
              公司地址：
            </p>
            <p class="tw-text-[20px] tw-text-[#333]">
              <span>深圳市丨福田区丨华富街道</span>
            </p>
            <p class="tw-text-[20px] tw-text-[#333]">
              <span>新田社区深南大道 1006 号</span>
            </p>
            <p class="tw-text-[20px] tw-text-[#333]">
              <span>深圳国际创新中心 A座 3503</span>
            </p>
          </div>
          <div class="item">
            <p class="tw-text-[20px] tw-font-[600] tw-text-[#333]">
              <icon-font type="Group2895" class="tw-text-[#3555FE]" />
              <!-- <Icon name="custom:group2895" class="tw-text-[#3555FE]" />-->
              咨询热线：
            </p>
            <p class="tw-text-[20px]">
              <span>0755-26907610</span>
            </p>
          </div>
        </div>
        <div class="address-right tw-flex tw-items-center tw-justify-center">
          <!-- <ClientOnly>
            <BaiduMap v-if="mapLoaded" :center="center" :zoom="zoom" />
          </ClientOnly> -->
          <img src="~/assets/images/about/map.png" class="tw-block tw-aspect-[855/427] tw-h-auto tw-w-full" />
        </div>
      </div>
    </div>
    <div class="experience tw-pt-[30px]">
      <div class="label tw-mb-[30px] tw-text-center tw-text-[30px] tw-text-[#fff]">
        请根据实际情况，选择您要体验的产品
      </div>
      <div
        class="tw-mx-auto tw-h-[1px] tw-bg-[linear-gradient(270deg,_rgba(255,255,255,0)_0%,_#FFFFFF_50%,_rgba(255,255,255,0)_100%)]
          2xl:tw-h-[2px]"></div>
      <div class="list">
        <div class="product-item">
          <img src="~/assets/images/about/experience/data.png" alt="" class="picture" />
          <div class="product-name">得理法搜</div>
          <div class="product-intro">法律难题 就找得理法搜</div>
          <div class="product-enter" @click="onGotoProduct('data')">免费体验</div>
        </div>
        <div class="product-item">
          <img src="~/assets/images/about/experience/dls.png" alt="" class="picture" />
          <div class="product-name">得理律助</div>
          <div class="product-intro">专为律师打造的智能助手</div>
          <div class="product-enter" @click="onGotoProduct('dls')">免费体验</div>
        </div>
        <div class="product-item">
          <img src="~/assets/images/about/experience/xl.png" alt="" class="picture" />
          <div class="product-name">小理AI</div>
          <div class="product-intro">业内领先的法律行业AI大模型</div>
          <div class="product-enter" @click="onGotoProduct('ai')">免费体验</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .container {
    width: 100%;

    .tip {
      position: relative;

      &::after {
        position: absolute;
        bottom: -16px;
        left: 50%;
        width: 32px;
        height: 6px;
        content: "";
        background: #4285f4;
        transform: translateX(-16px);
      }
    }

    .banner {
      width: 100%;
      height: 1017px;
      overflow: hidden;
      background-image: url("~/assets/images/about/banner.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;

      .title-wrap {
        width: fit-content;
        height: fit-content;
        margin: 300px auto 0;
        overflow: hidden;
        text-align: center;

        h1 {
          @apply ~'tw-text-[30px] tw-leading-[66px]' mi:tw-text-[30px] mi:tw-leading-[66px] sm:tw-text-[56px] sm:tw-leading-[66px] md:tw-text-[86px] md:tw-leading-[121px];

          margin-top: 28px;
          font-weight: 600;
          color: #fff;
        }

        h3 {
          @apply ~'tw-text-[20px]' mi:tw-text-[20px] sm:tw-text-[36px] md:tw-text-[36px];

          color: #fff;
        }
      }
    }

    .introduction {
      @apply mi:tw-p-[20px] sm:tw-px-[50px] sm:tw-py-[130px] 2xl:tw-px-[150px] 2xl:tw-py-[170px];

      width: 100%;
      overflow: hidden;
      background-image: url("~/assets/images/about/introduction/bg.png");
      background-size: cover;

      .content {
        @apply ~ ' tw-p-[80px]' mi:tw-px-[40px] sm:tw-px-[80px] xl:tw-p-[170px] xl:tw-pt-[80px];

        margin: 0 auto;
        background: #fff;
        border-radius: 24px;
        box-shadow: 0 8px 36px 0 rgba(44, 60, 180, 15%);

        .box {
          @apply tw-flex tw-flex-col tw-items-center md:tw-flex-row md:tw-justify-between md:tw-space-x-[72px];
        }

        h1 {
          @apply ~'tw-mt-[56px] tw-text-[40px]';

          position: relative;
          font-weight: 600;
          line-height: 47px;
          color: #333;
          text-align: center;
        }

        img {
          @apply ~'tw-wh-[240px_96px] tw-mt-[70px]' xl:tw-wh-[534px_212px];
        }

        .text {
          h2 {
            @apply ~'tw-text-center tw-text-[32px]' md:tw-text-left;

            margin-top: 72px;
            margin-bottom: 16px;
            font-size: 36px;
            font-weight: 600;
            line-height: 50px;
            color: #1d2129;
          }

          p {
            margin-bottom: 0;
            font-size: 24px;
            font-weight: 400;
            line-height: 40px;
            color: #5a5d66;
          }
        }
      }
    }

    .founder {
      @apply mi:tw-py-[130px] lg:tw-pt-[96px];

      .tip {
        position: relative;

        &::after {
          position: absolute;
          bottom: -16px;
          left: 50%;
          width: 32px;
          height: 6px;
          content: "";
          background: #4285f4;
          // border-radius: 2px;
          transform: translateX(-50%);
        }
      }

      .box {
        @apply ~'tw-mt-[70px]' tw-flex tw-flex-wrap tw-justify-center mi:tw-space-y-[102px] mi:tw-px-[180px] sm:tw-justify-center md:tw-px-[200px] lg:tw-space-x-[100px] lg:tw-space-y-0 lg:tw-px-[0];

        .founder-item {
          @apply ~'tw-w-[388px]' mi:tw-w-[194px] sm:tw-w-[388px] lg:tw-w-[291px] xl:tw-w-[388px];

          .photo-card {
            position: relative;
            overflow: hidden;
            border-radius: 12px;

            img {
              @apply ~'tw-wh-[194px_212px]' mi:tw-wh-[194px_212px] sm:tw-wh-[388px_424px] lg:tw-wh-[291px_318px] xl:tw-wh-[388px_424px];

              display: block;
              width: 100%;
              object-fit: cover;
            }

            .title-overlay {
              position: absolute;
              right: 0;
              bottom: 0;
              left: 0;
              display: flex;
              flex-direction: column;
              gap: 6px;
              padding: 20px 20px 22px;
              background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 60%));

              .name-row {
                display: flex;
                gap: 12px;
                align-items: center;
              }

              .accent-bar {
                flex-shrink: 0;
                width: 5px;
                height: 28px;
                background: #4285f4;
                border-radius: 2px;
              }

              .name {
                @apply ~'tw-text-[32px]' mi:tw-text-[18px] md:tw-text-[26px] lg:tw-text-[22px] xl:tw-text-[26px];

                font-weight: 600;
                line-height: 1.3;
                color: #fff;
              }

              .profession {
                @apply ~'tw-text-[16px]' mi:tw-text-[12px] md:tw-text-[16px] lg:tw-text-[14px] xl:tw-text-[16px];

                padding-left: 17px;
                color: rgba(255, 255, 255, 85%);
              }
            }
          }

          .info {
            margin-top: 24px;
            font-size: 17px;
            line-height: 40px;
          }
        }
      }
    }

    .honor {
      @apply mi:tw-py-[130px] sm:tw-py-[130px] md:tw-py-[148px];

      position: relative;
      width: 100%;
      background-image: url("~/assets/images/about/honorary-certificate/bg.png");
      background-size: cover;

      h1 {
        margin-bottom: 44px;
        font-size: 40px;
        font-weight: 600;
        line-height: 68px;
        color: #1d2129;
        text-align: center;
      }

      h3 {
        @apply ~'' mi:tw-px-[77px] sm:tw-px-[77px] lg:tw-px-[200px] xl:tw-px-[386px];

        margin-bottom: 80px;
        font-size: 24px;
        font-weight: 400;
        line-height: 34px;
        color: #4e5969;

        span {
          font-size: 32px;
        }
      }

      .carousel {
        @apply tw-hidden sm:tw-hidden md:tw-block md:tw-w-[calc(100%-100px)] lg:tw-w-[100%] xl:tw-w-[1368px];

        margin: 0 auto;
        margin-top: 140px;

        .ant-carousel {
          .patent-certificate,
          .honorary-certificate,
          .member-unit {
            @apply md:tw-h-[113.3px] md:tw-w-[0] lg:tw-h-[170px] lg:tw-w-[100%] xl:tw-w-[1368px];

            .img-wrap {
              display: flex;
              align-items: center;
              justify-content: space-around;

              .img-item {
                position: relative;
                cursor: pointer;

                &::after {
                  position: absolute;
                  top: 0;
                  left: 0;
                  display: block;
                  width: 0;
                  height: 170px;
                  content: "";
                  background-color: rgba(0, 0, 0, 50%);
                }
              }
            }
          }

          .patent-certificate {
            .img-item {
              img {
                @apply ~' tw-wh-[124px_170px]' md:tw-wh-[82.7px_113.3px] lg:tw-wh-[124px_170px];
              }

              &:hover::after {
                @apply ~' tw-wh-[124px_170px]' md:tw-wh-[82.7px_113.3px] lg:tw-wh-[124px_170px];
              }
            }
          }

          .honorary-certificate {
            .img-item {
              img {
                @apply ~'tw-wh-[124px_170px]' md:tw-wh-[82.7px_113.3px] lg:tw-wh-[124px_170px];
              }

              &:hover::after {
                @apply ~' tw-wh-[124px_170px]' md:tw-wh-[82.7px_113.3px] lg:tw-wh-[124px_170px];
              }
            }
          }

          .member-unit {
            // .img-item {
            //   img {
            //     @apply ~' tw-wh-[260px_170px]' md:tw-wh-[173.3px_113.3px] lg:tw-wh-[260px_170px];
            //   }

            //   &:hover::after {
            //     @apply ~' tw-wh-[260px_170px]' md:tw-wh-[173.3px_113.3px] lg:tw-wh-[260px_170px];
            //   }
            // }
            img {
              @apply ~'tw-wh-[124px_170px]' md:tw-wh-[82.7px_113.3px] lg:tw-wh-[124px_170px];
            }

            &:hover::after {
              @apply ~' tw-wh-[124px_170px]' md:tw-wh-[82.7px_113.3px] lg:tw-wh-[124px_170px];
            }
          }

          .prev-arrow,
          .next-arrow {
            @apply !tw-hidden md:!tw-flex lg:!tw-hidden xl:!tw-flex;

            top: 10px;
            // display: flex !important;
            align-items: center;
            justify-content: center;
            width: 42px;
            height: 100%;
            background: #fff;
            border: 1px solid #b9c5d2;

            .arrow {
              font-size: 23px;
              color: #4e5969;
            }

            &:hover {
              background-color: #2f78ff;

              .arrow {
                color: #fff;
              }
            }
          }

          .prev-arrow {
            left: -42px;
          }

          .next-arrow {
            right: -42px;
          }
        }
      }

      .picture-list {
        @apply ~'tw-gap-[48px] tw-justify-between' tw-flex tw-flex-wrap mi:tw-mx-auto mi:tw-w-[360px] mi:tw-gap-[30px] mi:tw-px-[20px] sm:tw-mx-auto sm:tw-w-[500px] md:tw-hidden;

        margin-top: 140px;

        img {
          @apply ~' tw-wh-[124px_170px]' mi:tw-wh-[82.7px_113.3px] sm:tw-wh-[124px_170px];
        }
      }
    }

    .honor-showcase {
      width: 100%;

      .showcase-section {
        height: 844px;
        padding-top: 148px;
        background-size: cover;
        //奇数
        &:nth-child(odd) {
          background-image: url("~/assets/images/about/honorary-certificate/bg.png");
        }

        //偶数
        &:nth-child(even) {
          background-image: url("~/assets/images/about/honorary-certificate/bg2.png");
        }

        .showcase-title-wrap {
          position: relative;
          margin-bottom: 154px;
          text-align: center;

          .showcase-title {
            display: inline-block;
            margin-bottom: 0;
            font-size: 36px;
            font-weight: 600;
            line-height: 1.3;
            color: #1f1f1f;

            &::after {
              position: absolute;
              bottom: -16px;
              left: 50%;
              width: 32px;
              height: 6px;
              content: "";
              background: #4285f4;
              transform: translateX(-50%);
            }
          }
        }

        .showcase-row {
          display: flex;
          flex-wrap: wrap;
          gap: 40px 60px;
          align-items: flex-start;
          justify-content: center;
          //max-width: 1368px;
          padding: 0 60px;
          margin: 0 auto;
        }

        .showcase-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 160px;
          cursor: pointer;

          .showcase-img-wrap {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 130px;
            height: 170px;

            img {
              width: 130px;
              height: 170px;
              object-fit: contain;
            }
          }

          .showcase-label {
            margin-top: 20px;
            font-size: 14px;
            line-height: 1.6;
            color: #4e5969;
            text-align: center;
            word-break: break-all;
          }
        }
      }

      :deep(.ant-tooltip) {
        max-width: none;

        .ant-tooltip-arrow::before {
          background-color: transparent;
        }

        .ant-tooltip-inner {
          padding: 0;
          background-color: transparent;

          .img-enlarge {
            p {
              width: fit-content;
              height: 28px;
              padding: 0 4px;
              margin-bottom: 0;
              font-size: 14px;
              font-weight: 400;
              line-height: 28px;
              color: #fff;
              background: #494949;
            }

            img {
              height: 408px;
              padding: 8px;
              background-color: #fff;
              border: 1px solid #dfdfe0;
              box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 11%);
            }
          }
        }
      }
    }

    .develop-history {
      img {
        width: 100%;
        height: auto;
      }
    }

    .company-news {
      @apply mi:tw-py-[40px] sm:tw-py-[60px] md:tw-py-[80px] lg:tw-py-[100px];

      background: url("~/assets/images/about/bg.png") no-repeat center center;
      background-size: cover;

      .company-news-inner {
        @apply mi:tw-px-[16px] sm:tw-px-[24px] md:tw-px-[40px] lg:tw-px-[88px];

        //max-width: 1368px;
        margin: 0 auto;
      }

      .company-news-title-wrap {
        position: relative;
        margin-bottom: 48px;
        text-align: center;

        .company-news-title {
          @apply mi:tw-text-[22px] sm:tw-text-[26px] md:tw-text-[32px] lg:tw-text-[40px];

          display: inline-block;
          margin-bottom: 0;
          font-weight: 600;
          line-height: 1.3;
          color: #1f1f1f;

          &::after {
            position: absolute;
            bottom: -16px;
            left: 50%;
            width: 32px;
            height: 6px;
            content: "";
            background: #4285f4;
            transform: translateX(-50%);
          }
        }
      }

      .company-news-tabs {
        @apply mi:tw-gap-[8px] sm:tw-gap-[12px] md:tw-gap-[16px] lg:tw-gap-[20px];
        @apply mi:tw-mb-[20px] sm:tw-mb-[24px] md:tw-mb-[28px] lg:tw-mb-[36px];
        @apply mi:tw-flex-wrap sm:tw-flex-nowrap;

        display: flex;
        justify-content: center;

        .company-news-tab {
          @apply mi:tw-px-[10px] mi:tw-py-[5px] mi:tw-text-[13px] sm:tw-px-[12px] sm:tw-py-[6px] sm:tw-text-[14px] lg:tw-px-[16px] lg:tw-py-[8px] lg:tw-text-[16px];

          color: #666;
          white-space: nowrap;
          cursor: pointer;
          border-radius: 12px;
          transition: all 0.2s;

          &.active {
            font-weight: 600;
            color: #fff;
            background: #3555fe;
          }

          &:hover:not(.active) {
            color: #4285f4;
          }
        }
      }

      .company-news-grid {
        @apply mi:tw-grid-cols-1 sm:tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3;
        @apply mi:tw-gap-[16px] sm:tw-gap-[20px] md:tw-gap-[24px] lg:tw-gap-[48px];
        @apply mi:tw-mb-[32px] sm:tw-mb-[40px] lg:tw-mb-[60px];

        display: grid;

        .company-news-card {
          @apply mi:tw-p-[16px] sm:tw-p-[20px] md:tw-p-[24px] lg:tw-p-[40px_48px];

          display: block;
          height: auto;
          aspect-ratio: 550 / 674;
          overflow: hidden;
          background: #fff;
          border-radius: 8px;
          box-shadow: 0 8px 32px 0 rgba(168, 179, 255, 20%);
          transition:
            box-shadow 0.2s,
            transform 0.2s;

          &:hover {
            box-shadow: 0 8px 24px rgba(66, 133, 244, 15%);
            transform: translateY(-2px);
          }

          .company-news-card-img {
            width: 100%;
            aspect-ratio: 430 / 270;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              transition: transform 0.3s;
            }
          }

          &:hover .company-news-card-img img {
            transform: scale(1.03);
          }

          .company-news-card-body {
            @apply mi:tw-mt-[12px] sm:tw-mt-[16px] lg:tw-mt-[24px];

            margin-top: 40px;

            .company-news-card-label {
              @apply mi:tw-text-[12px] sm:tw-text-[13px] lg:tw-text-[15px];

              font-size: 18px;
              color: #999;
            }

            .company-news-card-title {
              @apply mi:tw-mt-[8px] mi:tw-text-[15px] sm:tw-mt-[10px] sm:tw-text-[16px] md:tw-text-[18px] lg:tw-mt-[16px] lg:tw-text-[22px] xl:tw-text-[36px];

              display: -webkit-box;
              overflow: hidden;
              //font-size: 36px;
              font-weight: 600;
              line-height: 1.5;
              color: #1f1f1f;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
        }
      }

      .company-news-pagination {
        display: flex;
        gap: 16px;
        align-items: center;
        justify-content: center;

        .news-nav-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 60px;
          height: 52px;
          cursor: pointer;
          background: rgba(255, 255, 255, 90%);
          border: 1px solid rgba(10, 92, 255, 50%);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 10%);
          transition: background 0.2s;

          &:hover {
            background: #eef2ff;
          }

          img {
            width: 16px;
            height: 16px;
          }
        }

        .news-dots {
          display: flex;
          gap: 8px;

          .news-dot {
            width: 8px;
            height: 8px;
            cursor: pointer;
            background: #ccc;
            border-radius: 50%;
            transition:
              background 0.2s,
              transform 0.2s;

            &.active {
              background: #4285f4;
              transform: scale(1.3);
            }
          }
        }
      }
    }

    .origin {
      @apply ~'tw-py-[130px]' md:tw-py-[150px];

      width: 100%;
      background: #f5f9ff;

      @media (max-width: 800px) {
        .box1 {
          display: none;

          .row {
            height: 130px;
          }

          .img {
            height: 130px;
          }

          .text {
            width: 200px;
          }
        }

        .box2 {
          display: block;

          .item {
            img {
              height: 260px;
            }
          }

          .text {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 400px;
            height: 260px;

            .icon-wrap {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 96px;
              height: 96px;
              margin-bottom: 12px;
              background: #f5f9ff;
              border-radius: 96px;

              .anticon {
                font-size: 54px;
              }
            }

            .desc {
              font-size: 20px;
              font-weight: 500;
              line-height: 34px;
              color: #4e5969;
            }
          }

          .one {
            background: #2f78ff;

            .desc {
              color: #fff;
            }
          }

          .three,
          .five {
            background: #fff;
          }

          .one,
          .three,
          .five {
            &::after {
              position: absolute;
              bottom: -13px;
              display: inline-block;
              width: 26px;
              height: 26px;
              content: "";
              background-color: #2f78ff;
              transform: rotate(-45deg);
            }
          }

          .three::after {
            background-color: #fff;
          }

          .five::after {
            top: -13px;
            bottom: none;
            background-color: #fff;
          }
        }
      }

      @media (min-width: 800px) {
        .row {
          height: 195px;
        }

        .item {
          img {
            height: 195px;
          }
        }

        .text {
          width: 300px;
        }
      }

      h1 {
        margin-bottom: 60px;
        font-size: 40px;
        font-weight: 600;
        line-height: 68px;
        color: #1d2129;
        text-align: center;
      }

      h4 {
        margin-bottom: 60px;
        font-size: 24px;
        font-weight: 400;
        line-height: 34px;
        color: #4e5969;
        text-align: center;

        &:nth-of-type(1) {
          margin-bottom: 0;
        }
      }

      .content {
        width: fit-content;
        // height: 520px;
        margin: 0 auto;

        .row {
          // height: 260px;
          @apply ~' tw-h-[260px]' md:tw-h-[195px] lg:tw-h-[195px] xl:tw-h-[260px];

          display: flex;

          .item {
            flex: 1;

            img {
              // height: 260px;
              @apply ~' tw-h-[260px]' md:tw-h-[195px] lg:tw-h-[195px] xl:tw-h-[260px];
            }
          }

          .text {
            // width: 400px;
            @apply ~' tw-w-[400px]' md:tw-w-[300px] lg:tw-w-[300px] xl:tw-w-[400px];

            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .icon-wrap {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 96px;
              height: 96px;
              margin-bottom: 12px;
              background: #f5f9ff;
              border-radius: 96px;

              .anticon {
                font-size: 54px;
              }
            }

            .desc {
              font-size: 20px;
              font-weight: 500;
              line-height: 34px;
              color: #4e5969;
            }
          }

          .one {
            background: #2f78ff;

            .desc {
              color: #fff;
            }
          }

          .three,
          .five {
            background: #fff;
          }

          .one,
          .three,
          .five {
            &::after {
              position: absolute;
              bottom: -13px;
              display: inline-block;
              width: 26px;
              height: 26px;
              content: "";
              background-color: #2f78ff;
              transform: rotate(-45deg);
            }
          }

          .three::after {
            background-color: #fff;
          }

          .five::after {
            top: -13px;
            bottom: none;
            background-color: #fff;
          }
        }
      }

      .box2 {
        .item {
          img {
            @apply ~'' mi:tw-h-[195px] sm:tw-h-[260px];
          }
        }

        .text {
          @apply ~'' mi:tw-wh-[300px_195px] sm:tw-wh-[400px_260px];
        }
      }
    }

    .map {
      @apply ~'tw-py-[130px]' sm:tw-py-[174px];

      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      background-image: url("~/assets/images/about/map-bg.png");
      background-repeat: no-repeat;
      background-size: cover;

      .address {
        @apply ~'tw-gap-x-[126px] tw-gap-y-[32px]' tw-justify-center;

        display: flex;
        flex-wrap: wrap;
        align-items: center;
        padding: 0 40px;

        &-left {
          width: fit-content;

          h1 {
            position: relative;
            margin-bottom: 84px;
            font-size: 36px;
            font-weight: 600;
            line-height: 68px;
            color: #1d2129;

            &::after {
              position: absolute;
              bottom: -7px;
              left: 0;
              width: 32px;
              height: 6px;
              content: "";
              background: #3555fe;
            }
          }

          h3 {
            margin-bottom: 24px;
            font-size: 24px;
            font-weight: 600;
            line-height: 34px;
            color: #1d2129;
          }

          .item {
            margin-bottom: 24px;

            h4 {
              margin-bottom: 4px;
              font-size: 20px;
              font-weight: 600;
              line-height: 34px;
              color: #1d2129;
            }

            p {
              .anticon {
                margin-right: 5px;
                font-size: 24px;
              }

              span {
                font-size: 16px;
                font-weight: 400;
                line-height: 34px;
                color: #4e5969;
              }
            }

            &:last-child {
              margin-bottom: 0;
            }
          }
        }

        &-right {
          @apply ~' tw-wh-[100%_400px]' sm:tw-wh-[676px_400px];
        }
      }
    }

    .experience {
      @apply ~"tw-bg-[url('~/assets/images/about/experience/minibg.png')]" lg:tw-bg-[url('~/assets/images/about/experience/bg.png')];

      width: 100%;
      // background-image: url("~/assets/images/about/experience/minibg.png");
      background-size: cover;

      .list {
        @apply ~'tw-w-[320px] tw-gap-y-[120px]' tw-mx-auto tw-flex tw-flex-wrap tw-items-center tw-justify-center md:tw-w-full md:tw-justify-around;
        @apply ~'tw-py-[72px]';

        .product-item {
          @apply ~'tw-text-white tw-flex-col' tw-flex tw-items-center;

          .picture {
            @apply ~"tw-mb-[16px] tw-wh-[90px]" md:tw-hidden;
          }

          .product-name {
            @apply ~'tw-mb-[18px] tw-text-[32px]' tw-font-bold;
          }

          .product-intro {
            @apply ~'tw-mb-[24px] tw-text-[24px]' md:tw-mb-[38px];
          }

          .product-enter {
            @apply ~ 'tw-h-[46px] tw-leading-[46px]' tw-cursor-pointer tw-bg-white tw-text-[#2A3ACC];
            @apply ~'tw-px-[27px] tw-rounded-[24px]';
            @apply ~'tw-text-[20px] tw-text-center';

            &:hover {
              background-color: rgb(242, 243, 245);
            }

            &:active {
              background-color: rgb(201, 205, 212);
            }
          }
        }
      }
    }

    :deep(.ant-tooltip) {
      max-width: none;

      .ant-tooltip-arrow::before {
        background-color: transparent;
      }

      .ant-tooltip-inner {
        padding: 0;
        background-color: transparent;

        .img-enlarge {
          p {
            width: fit-content;
            height: 28px;
            padding: 0 4px;
            margin-bottom: 0;
            font-size: 14px;
            font-weight: 400;
            line-height: 28px;
            color: #fff;
            background: #494949;
          }

          img {
            height: 408px;
            padding: 8px;
            background-color: #fff;
            border: 1px solid #dfdfe0;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 11%);
          }
        }
      }
    }
  }

  :deep(.BMapLabel) {
    position: absolute;
    top: 50% !important;
    left: 50% !important;
    z-index: 0;
    display: inline;
    padding: 22px !important;
    font:
      14px arial,
      sans-serif;
    font-size: 16px !important;
    color: #283548 !important;
    white-space: nowrap;
    cursor: inherit;
    user-select: none;
    background: #f9fbff !important;
    border: 1px solid transparent !important;
    border-radius: 8px;
    box-shadow: 4px 8px 8px 0 rgba(126, 153, 191, 40%);
    transform: translate(-47%, -120%);

    &::after {
      position: absolute;
      bottom: -8px;
      left: 50%;
      content: "";
      border: 10px solid transparent;
      border-top: 8px solid #fff;
      border-bottom: 0;
      transform: translateX(-50%);
    }
  }

  .map-label-container {
    position: relative;
  }

  .map-label {
    position: relative;
    z-index: 1;
  }

  .map-label-arrow {
    position: absolute;
    bottom: -8px;
    left: 50%;
    z-index: 0;
    width: 0;
    height: 0;
    border-color: #f9fbff transparent transparent;
    border-style: solid;
    border-width: 8px 8px 0;
    transform: translateX(-50%);
  }

  :deep(.custom-label::after) {
    position: absolute;
    bottom: -8px;
    left: 50%;
    z-index: 0;
    width: 0;
    height: 0;
    content: "";
    border-color: #f9fbff transparent transparent;
    border-style: solid;
    border-width: 8px 8px 0;
    transform: translateX(-50%);
  }

  /* 去掉百度地图logo--begin */

  /* :deep(.BMap_cpyCtrl) {
    display: none;
  }

  :deep(.anchorBL) {
    display: none;
  } */

  /* 去掉百度地图logo--end */
</style>
